// components/ClientSchedulesDrawer/EmptyState.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { Schedule as ScheduleIcon } from "@mui/icons-material";

const EmptyState = () => {
  return (
    <Box sx={{ textAlign: "center", py: 8 }}>
      <ScheduleIcon sx={{ fontSize: 48, color: "#cbd5e1", mb: 2 }} />
      <Typography variant="body1" color="text.secondary" gutterBottom>
        No schedules found
      </Typography>
      <Typography variant="caption" color="text.secondary">
        No day to day schedules have been created for this client.
      </Typography>
    </Box>
  );
};

export default EmptyState;